import React, { useEffect } from 'react';
import queryString from 'query-string';
import s from './style.module.css';
import logo from '@Images/logo.webp';
import { URL } from '@Pages/url';
import { AreaKey, GetPrefectures, CTA_HIDDEN_PAGES } from '@Pages/setting';
import LazyableImage from '@Components/lazyable_image/view';
import { isBusinessTime } from '@Util/util';
import FreedialSVGIcon from '@Components/svg_icon/freedial';

type FooterProps = {
    courseId?: string;
};

export const Footer = (props: FooterProps) => {
    const ref = React.useRef<HTMLDivElement>();
    const footerRef = React.useRef<HTMLDivElement>();
    const footerContentRef = React.useRef<HTMLDivElement>();
    const currentPage = typeof window !== 'undefined' ? window.location.pathname : '';

    let currentPosition = 0;
    let timer = false;

    const controlFooter = () => {
        if (!footerRef.current) return;

        const footerTop = footerRef.current.offsetTop;
        const contentHeight = footerContentRef.current.clientHeight;

        if (timer !== false) clearTimeout(timer);

        // 最後までスクロールした場合
        if (window.scrollY + window.innerHeight > footerTop + contentHeight) {
            ref.current.style.position = 'relative';
            ref.current.style.display = 'flex';
        } else {
            ref.current.style.position = 'fixed';

            if (currentPosition < window.scrollY) ref.current.style.display = 'none';
            else ref.current.style.display = 'flex';
        }

        timer = setTimeout(() => {
            ref.current.style.display = 'flex';
        }, 500);

        currentPosition = window.scrollY;
    };

    useEffect(() => {
        if (CTA_HIDDEN_PAGES.includes(window.location.pathname)) return;
        window.addEventListener('scroll', controlFooter);
        return () => window.removeEventListener('scroll', controlFooter);
    }, []);

    const areaParams = (area: AreaKey) => {
        return queryString.stringify({ 'prefecture_codes[]': GetPrefectures(area).map((p) => p.code) });
    };
    return (
        <footer ref={footerRef} className={s.footer}>
            <div ref={footerContentRef} className={s.footer_component}>
                <div className={s.footer_left}>
                    <LazyableImage src={logo} alt='住地ゴルフ' width={210} height={30} />
                </div>
                <div className={s.footer_right}>
                    <ul>
                        <li>
                            <a href={URL.HOME}>ホーム</a>
                        </li>
                        <li>
                            ゴルフ会員権検索
                            <br />（<a href={`${URL.COURSES}?${areaParams('kanto')}`}> 関東 </a>、
                            <a href={`${URL.COURSES}?${areaParams('kansai')}`}> 関西 </a>、
                            <a href={`${URL.COURSES}?${areaParams('chubu')}`}> 中部 </a>、
                            <a href={`${URL.COURSES}?${areaParams('others')}`}> その他 </a>）
                        </li>
                        <li>
                            <a href={URL.INFO_NEWS}>住地ゴルフからのお知らせ</a>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <a href={URL.KNOWLEDGE}>会員権の基礎知識</a>
                        </li>
                        <li>
                            <a href={URL.INFO_GOLF}>ゴルフ場最新情報</a>
                        </li>
                        <li>
                            <a href={URL.MEMBER_VOICES}>お客様の声</a>
                        </li>
                        <li>
                            <a href={URL.COMPANY}>会社情報</a>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <a href={URL.CONTACT}>お問合せ</a>
                        </li>
                        <li>
                            <a href={URL.SITEPOLICY}>サイトポリシー</a>
                        </li>
                        <li>
                            <a href={URL.PRIVACY}>プライバシーポリシー</a>
                        </li>
                        <li>
                            <a href={URL.SITEMAP}>サイトマップ</a>
                        </li>
                    </ul>
                </div>
            </div>
            {!CTA_HIDDEN_PAGES.includes(currentPage) && <Cta ref={ref} courseId={props.courseId} />}
            <div className={s.copyright}>Copyright &copy; juchi. All right reserved.</div>
        </footer>
    );
};

export const Cta = React.forwardRef(function Cta(props: FooterProps, ref) {
    const contactUrl = props.courseId ? `${URL.CONTACT}?course_id=${props.courseId}` : URL.CONTACT;
    return (
        <div ref={ref} className={s.footer_tel_box}>
            {isBusinessTime() && (
                <>
                    <span className={s.footer_tel_text}>お電話でのお問合せ</span>
                    <FreedialSVGIcon className={s.footer_tel_icon} bg_fill='#fff' front_fill='#484848' />
                    <a className={s.footer_tel_main} href={'tel:0120-18-0072'}>
                        0120-18-0072
                    </a>
                </>
            )}
            <span className={s.footer_tel_text}>WEBでのお問合せ</span>
            <a className={s.footer_inquiry} href={contactUrl}>
                お問合せフォーム
            </a>
        </div>
    );
});

export default Footer;
